directive @scope(value: String!) on ENUM_VALUE

enum OpenDocsScope {
    _PLACEHOLDER_
}

directive @docs(
    route: String
    sort: [OpenDocsSortInput!]
    sortStack: [[String!]!]
    flattenTypes: Boolean
    sidebar: [OpenDocsPage]
    group: [String]
) repeatable on SCHEMA

input OpenDocsPage {
    type: OpenDocsSidebarItemType!
    key: String!
    group: String
    path: String
    pages: [OpenDocsPage]
}

enum OpenDocsSidebarItemType {
    OPERATION
    TYPE
}

directive @doc(
    group: [String!],
    path: String,
    example: OpenDocsExampleInput,
    scopes: [OpenDocsScope],
) on QUERY |
    FIELD_DEFINITION |
    MUTATION |
    SUBSCRIPTION |
    OBJECT |
    INPUT_OBJECT |
    ENUM |
    SCALAR |
    UNION

# TODO: finish
input OpenDocsExampleInput {
    """
    The name of the code
    """
    code: String!
}

input OpenDocsSortInput {
    node: String
    group: [String!]
    stack: Int
}